module.exports = __webpack_public_path__ + "static/27-029dbfcb7d460a3a8dc8a133d6e05ee4.png";